const routes = {
    home: '/',
    createDocumentType: '/createDocumentType',
    documentType: '/documentType',
    createDocument: '/createDocument',
    generateResult: '/generateResult',
    editDocument: '/editDocument',
    documentDetail: '/documentDetail',
    group: '/group',
    user: '/user',
    registration: '/registration',
    moderation: '/moderation',
    moderationGroup: '/moderation/group',
    moderationUser: '/moderation/user',
    administrator: '/admin',
};

export default routes;
